import type { ReactNode } from 'react';

import type { PublicCard } from '@/api/generated/game';

export interface SecretTaskProps {
  card: PublicCard;
  assigneeName: string;
  children?: ReactNode;
}

/**
 * 06 · Секретное задание, второй экран: текст, который читает один человек.
 *
 * Оформление секретности с текста не снимается — в этом и смысл. Лента
 * ограждения по всему полю, рамка акцентом и кегль 28 держат экран узнаваемым
 * издалека: сосед, поднявший глаза, видит, что смотреть сюда нельзя, и не
 * успевает прочитать.
 *
 * Своей колоды у экрана нет намеренно: цвет колоды выдал бы тип задания всему
 * столу, а секретная карточка не должна выдавать даже этого.
 */
export function SecretTask({ card, assigneeName, children }: SecretTaskProps) {
  return (
    <div
      className="relative flex min-h-screen flex-col justify-between border-2 border-acc bg-ground px-5 text-ink"
      style={{ paddingTop: 'var(--clown-safe-top)', paddingBottom: 'var(--clown-safe-bottom)' }}
    >
      <span aria-hidden className="pointer-events-none absolute inset-0 bg-tape opacity-15" />

      <p className="relative pt-4 text-meta uppercase tracking-widest text-acc">
        Только для {assigneeName} · вслух не читать
      </p>

      <div className="relative my-6 border-2 border-acc bg-ground p-5">
        <p className="text-secret">{card.text}</p>
      </div>

      <div className="relative">{children}</div>
    </div>
  );
}
